/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseDetailResponse } from '../../models/base-detail-response';

export interface DeleteBaseShift$Params {
  id: number;
  shiftCode: string;
}

export function deleteBaseShift(http: HttpClient, rootUrl: string, params: DeleteBaseShift$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteBaseShift.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('shiftCode', params.shiftCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseDetailResponse>;
    })
  );
}

deleteBaseShift.PATH = '/api/scheduler/bases/{id}/shifts/{shiftCode}';
